goog.provide("shadow.js.shim.module$ol$source$XYZ");
goog.provide("module$shadow_js_shim_module$ol$source$XYZ");
shadow.js.shim.module$ol$source$XYZ = shadow.js.nativeProvides["ol/source/XYZ"] = shadow$bridge("ol/source/XYZ");
module$shadow_js_shim_module$ol$source$XYZ.default = shadow.js.shim.module$ol$source$XYZ;
